gsap.registerPlugin(SplitText);

const unescapeHtml = (target) => {
  if (typeof target !== "string") return target;

  const patterns = {
    "&lt;": "<",
    "&gt;": ">",
    "&amp;": "&",
    "&quot;": '"',
    "&#x27;": "'",
    "&#x60;": "`",
  };

  return target.replace(/&(lt|gt|amp|quot|#x27|#x60);/g, (match) => {
    return patterns[match];
  });
};

class HomeSlide {
  constructor() {
    this.active = 0;
    this.disabled = false;
    this.$hero = document.querySelector("#top_hero");
    if (this.$hero && window.homeSlide && window.homeSlide.length) {
      this.$nav = this.$hero.querySelectorAll(".js-nav")[0];
      this.$comments = this.$hero.querySelectorAll(".js-comments")[0];
      this.$reference = this.$hero.querySelectorAll(".js-reference")[0];
      this.$image = this.$hero.querySelectorAll(".js-slide-image")[0];

      this.loadImage().then(() => {
        this.renderNav();
        this.eventBindNav();
        this.navActive();
        this.renderComments();
        this.renderImage();
        this.commentsAnim();
        this.renderReference();
      });
    }
  }

  loadImage() {
    const imageUrl = window.homeSlide[this.active].image;
    return new Promise((resolve, reject) => {
      if (!imageUrl) resolve("");
      const image = new Image();
      image.addEventListener("load", () => {
        resolve(imageUrl);
      });
      image.addEventListener("error", (error) => {
        reject(error);
      });
      image.src = imageUrl;
    });
  }

  renderNav() {
    let navHtml = "";
    window.homeSlide.forEach((slide, index) => {
      navHtml += `
<button class="p-top-hero__bar" type="button">
<span class="u-visually-hidden">${index + 1}</span>
</button>
`;
    });
    this.$nav.innerHTML = navHtml;
  }

  navActive() {
    gsap.utils
      .toArray(this.$nav.querySelectorAll("button"))
      .forEach((elm, index) => {
        elm.setAttribute("aria-current", this.active === index);
      });
  }

  eventBindNav() {
    gsap.utils
      .toArray(this.$nav.querySelectorAll("button"))
      .forEach((elm, index) => {
        elm.addEventListener("click", () => {
          if (index === this.active || this.disabled) return;
          this.setActive(index);
          this.next();
        });
      });
  }

  setActive(index) {
    this.active = index % window.homeSlide.length;
  }

  next() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
    this.navActive();
    this.loadImage().then(() => {
      this.renderImage();
      this.renderComments();
      this.commentsAnim();
      this.renderReference();
    });
  }

  renderComments() {
    const slide = window.homeSlide[this.active];
    let commentsHtml = "";
    slide.comments.forEach((comment) => {
      commentsHtml += `
<div class="js-comment">${unescapeHtml(comment.text)}</div>
      `;
    });
    this.$comments.innerHTML = commentsHtml;
  }

  renderImage() {
    const imageUrl = window.homeSlide[this.active].image;
    if (imageUrl) {
      this.$image.innerHTML = `
      <img src="${imageUrl}" alt="" style="opacity: 0;" />
      `;
    } else {
      this.$image.innerHTML = "";
    }
  }

  commentsAnim() {
    if (this.tl) {
      this.tl.kill();
    }
    this.tl = gsap.timeline({
      onComplete: () => {
        this.timerId = setTimeout(() => {
          this.disabled = true;
          this.commentsLeaveAnim();
        }, 3000);
      },
    });
    gsap.utils
      .toArray(this.$comments.querySelectorAll(".js-comment"))
      .forEach((elm, index) => {
        const splitText = new SplitText(elm);
        const chars = splitText.chars;
        this.tl.from(chars, {
          opacity: 0,
          ease: "power0.easeNone",
          stagger: 0.08,
          duration: 0.8,
          delay: index === 0 ? 0 : 0.8,
        });
      });
    // 参照の表示
    this.tl.to(this.$reference, {
      opacity: 1,
      ease: "power0.easeNone",
      duration: 1,
    });
    // 背景画像の表示
    gsap.to(this.$image.querySelector("img"), {
      opacity: 1,
      ease: "power0.easeNone",
      duration: 1,
    });
  }

  commentsLeaveAnim() {
    gsap.to(this.$comments.querySelectorAll(".js-comment"), {
      opacity: 0,
      ease: "power0.easeNone",
      onComplete: () => {
        setTimeout(() => {
          this.setActive(this.active + 1);
          this.next();
          this.disabled = false;
        }, 1000);
      },
    });
    gsap.to(this.$reference, { opacity: 0, ease: "power0.easeNone" });
    // 背景画像
    gsap.to(this.$image.querySelector("img"), {
      opacity: 0,
      ease: "power0.easeNone",
      duration: 1,
    });
  }

  renderReference() {
    this.$reference.classList.remove("-show");
    setTimeout(() => {
      const reference = window.homeSlide[this.active]["reference"];
      const html = `
  <a class="p-top-hero__link" href="${reference.url}">
  ${unescapeHtml(reference.text)}
  </a>
  `;
      this.$reference.innerHTML = html;
    }, 500);
  }
}

export { HomeSlide };
